import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import Select from 'components/Inputs/Select'
import TextInput from 'components/Inputs/TextInput'
import ProfessionalList from 'components/Lists/ProfessionalList'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container, Row } from '../styles'

export default function ConfigProfessionals () {
  const [loading, setLoading] = useState (true)
  const [professionals, setProfessionals] = useState ([])
  const [status, setStatus] = useState ({label: 'Ativos', value: 'active'})
  const [name, setName] = useState ('')
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getProfessionals ()
  }, [name, status])

  const getProfessionals = async () => {
    let filters = 'order_by=number'
    if (status.value === 'deleted') filters += '&deleted=true'
    else if ((status.value === 'all')) filters += ''
    else filters += `&status=${status.value}&deleted=false`
    if (name) filters += `&name=${encodeURIComponent (name)}`

    try {
      setLoading (true)
      const { data: professionals } = await cutileiApi.get (
        `/businesses/${businessId}/professionals?${filters}`, requestConfig
      )
      setProfessionals (professionals)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <Container>
      <Row style={{gap: 10, width: 600}}>
        <Select
          name='status'
          placeholder='Status...'
          value={status}
          options={[
            {label: 'Ativos', value: 'active'},
            {label: 'Inativos', value: 'inactive'},
            {label: 'Excluídos', value: 'deleted'},
            {label: 'Todos', value: 'all'}
          ]}
          onChange={(_, option) => setStatus (option)}
        />
        <TextInput
          value={name}
          placeholder='Pesquisar por nome'
          isClearable={true}
          onChange={e => setName (e.target.value)}
          onClear={() => setName ('')}
          inputStyle={{boxShadow: '0px 1px 10px -6px', paddingInline: 12}}
        />
      </Row>
      {loading ? <Loading/> : (
        <ProfessionalList professionals={professionals}/>
      )}
    </Container>
  )
}
